import React from 'react';

const Comment = ({ commentBox }) => (
  <div ref={commentBox} className='comments' style={{ width: '100%' }}></div>
);
export default Comment;
